import { useUserStore } from '@/to-fsd/shared/store/user';

// import { ROUTE_NAMES } from '@/to-fsd/shared/constants';
import { AtToastPlugin } from '@packages/aliftech-ui';
import { i18n } from '@/to-fsd/shared/lib/i18n';

const requirePermissions = permissions => {
  return async ({ next }) => {
    const userStore = useUserStore();

    const userPermissionNames = userStore.me.resource_access.merchant.roles;

    const hasPermissionToTargetRoute = permissions.every(permissionName =>
      userPermissionNames.includes(permissionName)
    );

    if (!hasPermissionToTargetRoute) {
      AtToastPlugin.error({
        title: i18n.global.t('pages.errorPage.messages.notAllowed'),
        duration: 7000,
      });
      return false;
    }

    return next();
  };
};

export default requirePermissions;
